import {useContext,useEffect,useState} from "react";
import {LiftCrmClientContext} from "./LiftCrmClientActions";
import {notifyProspRefresh} from "./newUi/prospRefresh";
import {confirmedBindingForCard} from "./liftCardBinding.mjs";
const money=value=>Number(value||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
const normalize=value=>String(value||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase();
export default function LiftCloseSaleAction({moduleId,record,onBegin,onSettled,onLinked,renderTrigger}){
  const context=useContext(LiftCrmClientContext);
  const [open,setOpen]=useState(false),[orders,setOrders]=useState([]),[query,setQuery]=useState("");
  const [error,setError]=useState(""),[loading,setLoading]=useState(false),[busy,setBusy]=useState(false);
  const [binding,setBinding]=useState(record?.manualSaleBinding||null);
  const confirmed=confirmedBindingForCard(moduleId,record,context?.sales||[]);
  const effectiveBinding=confirmed||binding;
  const [selected,setSelected]=useState(null),[acknowledge,setAcknowledge]=useState(false);
  const recordId=record?._rawPhone?`aurora_${record._rawPhone}`:record?.id;
  useEffect(()=>{setBinding(record?.manualSaleBinding||null);setOpen(false);setSelected(null);setError("");},[recordId,record?.manualSaleBinding]);
  const role=context?.authenticatedUser?.role;
  const canLink=!!recordId&&["consultant","manager","admin","superadmin"].includes(role);
  const load=async()=>{
    if(!canLink)return;
    setSelected(null);setQuery("");setAcknowledge(false);
    setOpen(true);setLoading(true);setError("");
    try{
      const r=await fetch(`/api/lift/card-orders?${new URLSearchParams({moduleId,recordId})}`,{credentials:"same-origin",cache:"no-store"});
      const j=await r.json();if(!r.ok||!j.ok)throw Error(j.error||"Não foi possível carregar pedidos.");
      setOrders(j.orders);
    }catch(e){setError(e.message);}finally{setLoading(false);}
  };
  const confirm=async()=>{
    if(!selected||busy)return;
    if(onBegin?.()===false){setError("Aguarde a gravação da ficha antes de vincular o pedido.");return;}
    setBusy(true);setError("");
    try{
      const r=await fetch("/api/lift/card-sale",{method:"POST",credentials:"same-origin",
        headers:{"Content-Type":"application/json"},body:JSON.stringify({moduleId,recordId,pedidoId:selected.pedidoId,confirmExistingLink:acknowledge})});
      const j=await r.json();if(!r.ok||!j.ok)throw Error(j.error||"Vínculo não confirmado.");
      setBinding(j.binding);context?.onCardLinked?.(j);context?.onOriginLinked?.(j.sale);onLinked?.(j.card);
      notifyProspRefresh();setOpen(false);
    }catch(e){setError(e.message);}finally{setBusy(false);onSettled?.();}
  };
  if(!canLink)return renderTrigger?renderTrigger({openPicker:()=>{},busy:false,canLink:false}):null;
  return <div onClick={renderTrigger?event=>event.stopPropagation():undefined}
    style={renderTrigger?{flex:1,minWidth:0}:{margin:"8px 0",padding:8,border:"1px solid #ded7c8",borderRadius:8}}>
    {renderTrigger?renderTrigger({openPicker:load,busy,canLink}):null}
    {effectiveBinding?.status==="confirmed"?<div role="status" style={{fontSize:12,fontWeight:700}}>
      Venda #{effectiveBinding.pedidoId} vinculada
      <div>Pedido #{effectiveBinding.pedidoId} · {money(effectiveBinding.saleValue)} · {effectiveBinding.saleDate?.slice(0,10)}</div>
      <div style={{fontSize:11,fontWeight:400,marginTop:4}}>Comprador no LIFT: {effectiveBinding.buyerName||"Não informado"}</div>
    </div>:!renderTrigger?<button type="button" onClick={load}>{binding?"Retomar vínculo da venda":"Venda fechada"}</button>:null}
    {open&&<div style={{display:"grid",gap:8,marginTop:8}}>
      <label>Buscar pedido LIFT<input value={query} onChange={e=>setQuery(e.target.value)} placeholder="Número, data, valor ou nome"/></label>
      {loading?<span>Carregando pedidos da mesma loja…</span>:<div style={{maxHeight:180,overflowY:"auto"}}>
        {orders.filter(order=>normalize([order.pedidoId,order.dataVenda,order.dataVenda?.slice(0,10).split("-").reverse().join("/"),
          order.valorTotal,money(order.valorTotal),order.buyerName].join(" ")).includes(normalize(query)))
          .sort((a,b)=>String(b.dataVenda).localeCompare(String(a.dataVenda))).map(order=><button type="button" key={order.pedidoId}
            aria-pressed={selected?.pedidoId===order.pedidoId} onClick={()=>{setSelected(order);setAcknowledge(false);}}
            style={{display:"block",width:"100%",textAlign:"left",padding:8,marginBottom:4,background:selected?.pedidoId===order.pedidoId?"#fff3ce":"white",border:"1px solid #ddd",borderRadius:6}}>
            #{order.pedidoId} · {order.dataVenda?.slice(0,10)} · {money(order.valorTotal)} · {order.buyerName}
          </button>)}
        {!orders.length&&<span>Nenhum pedido ativo encontrado nesta loja.</span>}
      </div>}
      {selected?.existingLink&&<label style={{fontSize:12}}><input type="checkbox" checked={acknowledge} onChange={e=>setAcknowledge(e.target.checked)}/>
        Confirmo a vinculação a esta conversa e a revisão do vínculo automático anterior, se houver.
      </label>}
      <small>O comprador pode ter outro nome ou telefone. A conversa e sua origem serão preservadas; não será criada outra venda.</small>
      <button type="button" disabled={!selected||busy||(!!selected.existingLink&&!acknowledge)} onClick={confirm}>{busy?"Confirmando vínculo…":"Confirmar venda fechada"}</button>
      <button type="button" disabled={busy} onClick={()=>setOpen(false)}>Fechar seletor</button>
    </div>}
    {error&&effectiveBinding?.status!=="confirmed"&&<div role="alert" style={{color:"#b91c1c",fontSize:12}}>{error}</div>}
  </div>;
}
